import { getConstantsFor } from "../asyncAction";

export const LOAD_IN_APP_MESSAGES = getConstantsFor("LOAD_IN_APP_MESSAGES");
export const LOAD_UNSEEN_MESSAGES_COUNT = getConstantsFor("LOAD_UNSEEN_MESSAGES_COUNT");
export const MARK_MESSAGE_AS_SEEN = getConstantsFor("MARK_MESSAGE_AS_SEEN");
export const MARK_MESSAGE_AS_HIDDEN = getConstantsFor("MARK_MESSAGE_AS_HIDDEN");
export const UNHIDE_MESSAGE = getConstantsFor("UNHIDE_MESSAGE");
